import React, {useEffect, useState} from "react";
import Chip from "@material-ui/core/Chip";
import HTTPClient from "../HTTPClient";
import {getMessage} from "../util";

const Clock = (props) => {
    const [distance, setDistance] = useState("00:00");


    useEffect(() => {
        const syncTime = () => HTTPClient({
            method: "get",
            url:
                process.env.REACT_APP_API_URL +
                "/now"
        })
            .then(response => {
                const now = new Date(response.data);
                const end = new Date(props.end_date);
                const the_distance = (end.getTime() - now.getTime())/1000;

                const hours = Math.floor((the_distance % ( 60 * 60 * 24)) / ( 60 * 60));
                const minutes = Math.floor((the_distance % (60 * 60)) /  60);
                const seconds = Math.floor((the_distance %  60) );
                const s_label = the_distance > 0 ? ((minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds)) : "00:00";

                setDistance(hours > 0 ? (hours+":"+s_label):s_label );

            })
            .catch((error) => {
                setDistance(getMessage(props.meeting.meeting_type,'synchronizing',props.messages));
            });

        syncTime();
        const intervalId = setInterval(syncTime, 500);

        return (() => {
            clearInterval(intervalId);
        });

    },[props.end_date,props.meeting.meeting_type,props.messages])



    return(
        <Chip label={distance} component={"span"}/>
    )
}

export default Clock;